module.exports = __webpack_public_path__ + "static/icons/snowing@2x-1afdc2172aeea5b3a7c175d76cb01535.png";